import { createContext } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import type {
  RegulationContract,
  RegulationHistoryContract,
} from '@raas/shared/src/features/regulation/contracts/regulation.type';
import type { PaginationParamsContract } from '@raas/shared/src/features/pagination';

export interface RegulationMyListDataContextContract {
  isMyListLoading: boolean;
  setIsMyListLoading: (isLoading: boolean) => void;
  myRegulations: RegulationContract[] | null;
  setMyRegulations: Dispatch<SetStateAction<RegulationContract[]>>;
  nextCursor: string | null;
  hasMore: boolean;
  paginationParams: PaginationParamsContract;
  setNextCursor: (cursor: string | null) => void;
  setHasMore: (hasMore: boolean) => void;
  setPaginationParams: Dispatch<SetStateAction<PaginationParamsContract>>;
  isHistoryListLoading: boolean;
  setIsHistoryListLoading: (isLoading: boolean) => void;
  myRegulationHistory: RegulationHistoryContract[] | null;
  setMyRegulationHistory: Dispatch<SetStateAction<RegulationHistoryContract[]>>;
}

const RegulationMyListDataContext = createContext<RegulationMyListDataContextContract | undefined>(
  undefined
);

export default RegulationMyListDataContext;
